export interface TVShow {
  id: string;
  title: string;
  category: string;
  image: string;
  description: string;
  episodes: number;
  currentEpisode: number;
  status: '更新中' | '已完结';
  rating: number;
  year: number;
  actors: string[];
  director: string;
  region: string;
  updateInfo: string;
  isHot: boolean;
  isNew: boolean;
  tags: string[];
  longDescription: string;
}

export const tvShows: TVShow[] = [
  {
    id: 'show-001',
    title: '繁花',
    category: '国产剧',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20period%20drama%20poster%20style%20with%20elegant%20Shanghai%20cityscape%20background%2C%20warm%20golden%20tones%2C%20nostalgic%201990s%20atmosphere%2C%20cinematic%20lighting%2C%20dramatic%20composition%2C%20film%20poster%20aesthetic%2C%20clean%20product%20photography%20with%20soft%20shadows%20and%20rich%20color%20gradients&width=800&height=1120&seq=show-001&orientation=portrait',
    description: '九十年代的上海处处是机遇与希望，阿宝凭借改革开放的春风和自己的努力，从默默无闻到成为上海滩的风云人物。',
    episodes: 30,
    currentEpisode: 30,
    status: '已完结',
    rating: 9.2,
    year: 2023,
    actors: ['胡歌', '马伊琍', '唐嫣', '辛芷蕾'],
    director: '王家卫',
    region: '中国大陆',
    updateInfo: '全30集',
    isHot: true,
    isNew: false,
    tags: ['剧情', '年代', '商战'],
    longDescription: '《繁花》是由王家卫执导并监制，胡歌、马伊琍、唐嫣、辛芷蕾等主演的年代剧。该剧改编自金宇澄的同名小说，讲述了20世纪九十年代初，煌煌大时代，人人争上游，阿宝也变成了宝总，成功过，失败过，在沪上弄潮儿女中留下一段传奇。故事通过阿宝的视角，展现了上海这座城市的变迁和人情冷暖。剧中不仅有扣人心弦的商战情节，更有细腻动人的情感描绘，是一部兼具艺术性与观赏性的精品剧作。',
  },
  {
    id: 'show-002',
    title: '庆余年第二季',
    category: '国产剧',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20fantasy%20drama%20poster%20with%20ancient%20palace%20architecture%20background%2C%20rich%20gold%20and%20red%20color%20palette%2C%20martial%20arts%20atmosphere%2C%20cinematic%20film%20poster%20style%2C%20dramatic%20lighting%20with%20soft%20shadows%2C%20clean%20product%20photography&width=800&height=1120&seq=show-002&orientation=portrait',
    description: '范闲身世之谜逐渐揭开，面对更加复杂的朝堂局势，他必须在各方势力之间寻找平衡，守护自己所珍视的一切。',
    episodes: 36,
    currentEpisode: 36,
    status: '已完结',
    rating: 8.9,
    year: 2024,
    actors: ['张若昀', '李沁', '陈道明', '吴刚'],
    director: '孙皓',
    region: '中国大陆',
    updateInfo: '全36集',
    isHot: true,
    isNew: true,
    tags: ['古装', '权谋', '武侠'],
    longDescription: '《庆余年第二季》延续了第一季的故事线，范闲在经历了一系列生死考验后，继续在庆国的权力漩涡中周旋。本季剧情更加紧凑，人物关系更加错综复杂。范闲不仅要面对来自朝堂内外的明枪暗箭，还要揭开自己身世的终极秘密。剧中融合了权谋、武侠、喜剧等多种元素，张若昀、李沁等主演的精彩演绎让角色更加丰满立体，是一部备受期待的古装巨制。',
  },
  {
    id: 'show-003',
    title: '黑暗荣耀',
    category: '韩剧',
    image: 'https://readdy.ai/api/search-image?query=Korean%20drama%20revenge%20thriller%20poster%20with%20dark%20moody%20atmosphere%2C%20flower%20symbolism%2C%20cold%20color%20tones%2C%20suspenseful%20cinematic%20style%2C%20elegant%20yet%20dark%20composition%2C%20film%20poster%20aesthetic%20with%20dramatic%20shadows%20and%20minimalist%20design&width=800&height=1120&seq=show-003&orientation=portrait',
    description: '年少时遭受校园暴力的文东恩，耗费多年时间精心策划了一场复仇大计，誓要让当年的施暴者付出代价。',
    episodes: 16,
    currentEpisode: 16,
    status: '已完结',
    rating: 9.1,
    year: 2023,
    actors: ['宋慧乔', '李到晛', '林智妍', '廉惠兰'],
    director: '安吉镐',
    region: '韩国',
    updateInfo: '全16集',
    isHot: true,
    isNew: false,
    tags: ['复仇', '悬疑', '剧情'],
    longDescription: '《黑暗荣耀》是由Netflix出品的韩国复仇剧，讲述了一个关于校园暴力和复仇的故事。女主角文东恩在高中时期遭受了残酷的校园暴力，被迫退学后，她用十几年的时间精心策划了一场完美的复仇。宋慧乔在剧中的表演令人震撼，将一个内心充满仇恨却又保持冷静理智的复仇者形象诠释得入木三分。该剧不仅获得了极高的收视率，更引发了社会对校园暴力问题的广泛讨论。',
  },
  {
    id: 'show-004',
    title: '眼泪女王',
    category: '韩剧',
    image: 'https://readdy.ai/api/search-image?query=Korean%20romantic%20comedy%20drama%20poster%20with%20elegant%20couple%20silhouette%2C%20soft%20pink%20and%20warm%20tone%20background%2C%20modern%20luxury%20aesthetic%2C%20cinematic%20lighting%2C%20film%20poster%20style%20with%20romantic%20atmosphere%2C%20clean%20product%20photography&width=800&height=1120&seq=show-004&orientation=portrait',
    description: ' Queens集团百货女王洪海仁与龙头里超市王子白贤宇，这对结婚三年的夫妻在面临离婚危机时，奇迹般重新相爱的故事。',
    episodes: 16,
    currentEpisode: 16,
    status: '已完结',
    rating: 8.7,
    year: 2024,
    actors: ['金秀贤', '金智媛', '朴成焄', '郭东延'],
    director: '张英宇',
    region: '韩国',
    updateInfo: '全16集',
    isHot: true,
    isNew: true,
    tags: ['爱情', '喜剧', '剧情'],
    longDescription: '《眼泪女王》由金秀贤和金智媛主演，讲述了一对财阀夫妇在面临婚姻危机时重新相爱的故事。洪海仁是Queens集团的第三代继承人，被称为百货女王；白贤宇则是龙头里超市的王子。两人结婚三年后，爱情在日复一日的生活中逐渐消磨。然而命运的转折让他们不得不重新审视彼此，在泪水和欢笑中找回了最初的心动。该剧以其精致的制作、出色的演技和温暖治愈的剧情赢得了观众的喜爱。',
  },
  {
    id: 'show-005',
    title: '怪奇物语第四季',
    category: '美剧',
    image: 'https://readdy.ai/api/search-image?query=American%20sci-fi%20horror%20series%20poster%20with%2080s%20retro%20nostalgic%20vibe%2C%20dark%20supernatural%20atmosphere%2C%20neon%20red%20glow%2C%20upside%20down%20world%20theme%2C%20cinematic%20film%20poster%20style%2C%20dramatic%20composition%20with%20mysterious%20lighting&width=800&height=1120&seq=show-005&orientation=portrait',
    description: '霍金斯小镇的平静再次被打破，一股更加危险的力量正在逼近，孩子们必须再次团结起来对抗来自逆世界的威胁。',
    episodes: 9,
    currentEpisode: 9,
    status: '已完结',
    rating: 9.3,
    year: 2022,
    actors: ['米莉·波比·布朗', '芬恩·伍法德', '薇诺娜·瑞德', '大卫·哈伯'],
    director: '达菲兄弟',
    region: '美国',
    updateInfo: '全9集',
    isHot: false,
    isNew: false,
    tags: ['科幻', '惊悚', '悬疑'],
    longDescription: '《怪奇物语》第四季将故事扩展到了更广阔的世界。在上季结尾星庭之战六个月后，主角们第一次分开了，各自面对高中生活的挑战。然而一个新的、更可怕的超自然威胁浮出水面，带来了一个关于霍金斯小镇的可怕谜团，这个谜团可能最终终结逆世界的恐怖。本季在制作规模和视觉效果上都达到了新的高度，剧情更加黑暗成熟，获得了观众和评论家的一致好评。',
  },
  {
    id: 'show-006',
    title: '继承之战第四季',
    category: '美剧',
    image: 'https://readdy.ai/api/search-image?query=American%20business%20drama%20poster%20with%20corporate%20power%20struggle%20theme%2C%20luxury%20modern%20skyscraper%20background%2C%20dark%20sophisticated%20color%20tones%2C%20cinematic%20film%20poster%20style%2C%20dramatic%20lighting%20with%20sharp%20contrasts%2C%20minimalist%20yet%20powerful%20composition&width=800&height=1120&seq=show-006&orientation=portrait',
    description: 'Waystar Royco出售给科技巨头GoJo的交易即将完成，罗伊家族的子女们预见到他们在公司中的地位将发生重大变化。',
    episodes: 10,
    currentEpisode: 10,
    status: '已完结',
    rating: 9.4,
    year: 2023,
    actors: ['布莱恩·考克斯', '杰瑞米·斯特朗', '莎拉·斯努克', '基南·卡尔金'],
    director: '马克·米罗',
    region: '美国',
    updateInfo: '全10集',
    isHot: false,
    isNew: false,
    tags: ['剧情', '商战', '家族'],
    longDescription: '《继承之战》第四季是这部艾美奖获奖剧集的最终季。随着Waystar Royco被出售给科技巨头GoJo的交易接近完成，罗伊家族的子女们面临着前所未有的挑战。权力、金钱和家族忠诚之间的冲突达到了白热化的程度。本季每一集都如同一部精密的戏剧作品，演员们的表演达到了巅峰，对话犀利而深刻，是一部关于权力腐化和家族悲剧的杰作。',
  },
  {
    id: 'show-007',
    title: '半泽直树第二季',
    category: '日剧',
    image: 'https://readdy.ai/api/search-image?query=Japanese%20business%20drama%20poster%20with%20banking%20and%20corporate%20theme%2C%20intense%20expression%20character%20portrait%2C%20dark%20blue%20and%20gold%20color%20palette%2C%20cinematic%20film%20poster%20style%2C%20dramatic%20lighting%20with%20sharp%20shadows%2C%20clean%20product%20photography&width=800&height=1120&seq=show-007&orientation=portrait',
    description: '半泽直树被外派到东京中央证券后，再次面对重重黑幕与不公，他依然坚持自己的信念，以牙还牙、加倍奉还。',
    episodes: 10,
    currentEpisode: 10,
    status: '已完结',
    rating: 9.0,
    year: 2020,
    actors: ['堺雅人', '上户彩', '及川光博', '片冈爱之助'],
    director: '福泽克雄',
    region: '日本',
    updateInfo: '全10集',
    isHot: false,
    isNew: false,
    tags: ['职场', '剧情', '热血'],
    longDescription: '《半泽直树》第二季改编自池井户润的小说，讲述了半泽直树被调往东京中央证券后的故事。在新的工作环境中，他面临了更多的不公和阴谋，但他依然坚持"以牙还牙，加倍奉还"的信念。本季不仅延续了第一季的紧张节奏和精彩剧情，还将舞台从银行业扩展到了更广阔的商业世界。堺雅人富有感染力的表演再次证明了他是日本最优秀的演员之一。',
  },
  {
    id: 'show-008',
    title: '咒术回战第二季',
    category: '动漫',
    image: 'https://readdy.ai/api/search-image?query=Japanese%20anime%20poster%20with%20supernatural%20action%20theme%2C%20dynamic%20character%20poses%20with%20energy%20effects%2C%20dark%20urban%20fantasy%20background%2C%20vibrant%20color%20contrast%2C%20anime%20film%20poster%20style%2C%20cinematic%20composition%20with%20dramatic%20lighting%20and%20clean%20product%20photography&width=800&height=1120&seq=show-008&orientation=portrait',
    description: '怀玉篇与涩谷事变篇，五条悟与夏油杰的过去被揭开，一场改变咒术界格局的大战即将在涩谷上演。',
    episodes: 23,
    currentEpisode: 23,
    status: '已完结',
    rating: 9.3,
    year: 2023,
    actors: ['榎木淳弥', '内田雄马', '濑户麻沙美', '中村悠一'],
    director: '御所园翔太',
    region: '日本',
    updateInfo: '全23集',
    isHot: true,
    isNew: false,
    tags: ['热血', '战斗', '奇幻'],
    longDescription: '《咒术回战》第二季分为"怀玉·玉折"篇和"涩谷事变"篇，讲述了五条悟和夏油杰在高专时期的往事，以及当下发生在涩谷的咒术界大战。本季在动画制作上达到了新的高度，战斗场面流畅震撼，情感刻画细腻深刻。特别是涩谷事变篇的剧情张力十足，每一集都让人心跳加速，是近年来日本动画的巅峰之作。',
  },
  {
    id: 'show-009',
    title: '一念关山',
    category: '国产剧',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20martial%20arts%20drama%20poster%20with%20ancient%20warrior%20couple%20theme%2C%20mountain%20landscape%20background%2C%20warm%20golden%20and%20crimson%20color%20palette%2C%20cinematic%20film%20poster%20style%2C%20dramatic%20lighting%20with%20epic%20composition%2C%20clean%20product%20photography&width=800&height=1120&seq=show-009&orientation=portrait',
    description: '江湖侠女任如意与六道堂堂主宁远舟相遇相知，二人携手并肩，共同守护家国天下，演绎了一段荡气回肠的江湖传奇。',
    episodes: 40,
    currentEpisode: 40,
    status: '已完结',
    rating: 8.5,
    year: 2023,
    actors: ['刘诗诗', '刘宇宁', '方逸伦', '何蓝逗'],
    director: '周靖韬',
    region: '中国大陆',
    updateInfo: '全40集',
    isHot: true,
    isNew: false,
    tags: ['古装', '武侠', '爱情'],
    longDescription: '《一念关山》讲述了一个发生在架空朝代的江湖故事。女主角任如意是江湖上有名的侠女，她与六道堂堂主宁远舟在一次任务中相遇，两人从最初的互相猜忌到后来的相知相守，共同经历了一系列惊心动魄的冒险。剧中不仅有精彩的武打场面，更有深刻的情感刻画和家国情怀，是一部制作精良、故事动人的古装武侠剧。',
  },
  {
    id: 'show-010',
    title: '狂飙',
    category: '国产剧',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20crime%20thriller%20drama%20poster%20with%20police%20and%20underworld%20theme%2C%20dark%20urban%20night%20background%2C%20intense%20color%20contrast%2C%20cinematic%20film%20poster%20style%2C%20dramatic%20lighting%20with%20gritty%20atmosphere%2C%20clean%20product%20photography%20with%20strong%20shadows&width=800&height=1120&seq=show-010&orientation=portrait',
    description: '一线刑警安欣与黑恶势力展开了长达二十年的生死较量，在全国政法队伍教育整顿的背景下，正义终于战胜邪恶。',
    episodes: 39,
    currentEpisode: 39,
    status: '已完结',
    rating: 9.5,
    year: 2023,
    actors: ['张译', '张颂文', '李一桐', '张志坚'],
    director: '徐纪周',
    region: '中国大陆',
    updateInfo: '全39集',
    isHot: true,
    isNew: false,
    tags: ['刑侦', '扫黑', '剧情'],
    longDescription: '《狂飙》是一部以扫黑除恶为主题的刑侦剧，讲述了以一线刑警安欣为代表的正义力量，与以高启强为首的黑恶势力长达二十年的斗争历程。该剧通过横跨二十年的群像叙事，全景式展现了时代变迁下的黑白较量与复杂人性。张译和张颂文的演技对决令人叹服，将正邪双方的复杂心理刻画得淋漓尽致。这部剧不仅是2023年收视率最高的电视剧，更引发了全社会对扫黑除恶的广泛关注。',
  },
  {
    id: 'show-011',
    title: '机智的医生生活第二季',
    category: '韩剧',
    image: 'https://readdy.ai/api/search-image?query=Korean%20medical%20drama%20poster%20with%20hospital%20and%20friendship%20theme%2C%20warm%20pastel%20color%20palette%2C%20heartwarming%20atmosphere%2C%20cinematic%20film%20poster%20style%2C%20soft%20natural%20lighting%2C%20clean%20product%20photography%20with%20gentle%20composition&width=800&height=1120&seq=show-011&orientation=portrait',
    description: '五位相识二十年的医生朋友，在医院里的日常故事，用温暖和幽默治愈每一个患者和彼此的心灵。',
    episodes: 12,
    currentEpisode: 12,
    status: '已完结',
    rating: 9.4,
    year: 2021,
    actors: ['曹政奭', '柳演锡', '郑敬淏', '金大明', '田美都'],
    director: '申源浩',
    region: '韩国',
    updateInfo: '全12集',
    isHot: false,
    isNew: false,
    tags: ['医疗', '友情', '喜剧'],
    longDescription: '《机智的医生生活》第二季延续了第一季的温暖风格，继续讲述律帝医院五位医生朋友的故事。他们不仅是专业精湛的医生，更是一群相识二十年的挚友。本季在保持幽默轻松基调的同时，更加深入地探讨了生命、死亡、爱情和友情等主题。每集都有让人笑中带泪的瞬间，是一部温暖治愈的佳作。',
  },
  {
    id: 'show-012',
    title: '莲花楼',
    category: '国产剧',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20martial%20arts%20mystery%20drama%20poster%20with%20ancient%20detective%20theme%2C%20traditional%20architecture%20background%2C%20elegant%20ink%20painting%20style%2C%20cinematic%20film%20poster%20aesthetic%2C%20soft%20natural%20lighting%2C%20clean%20product%20photography%20with%20refined%20composition&width=800&height=1120&seq=show-012&orientation=portrait',
    description: '闻名武林的四顾门门主李相夷隐姓埋名成为江湖游医李莲花，却在一次次案件中重现往日风采。',
    episodes: 40,
    currentEpisode: 40,
    status: '已完结',
    rating: 8.6,
    year: 2023,
    actors: ['成毅', '曾舜晞', '肖顺尧', '陈都灵'],
    director: '郭虎',
    region: '中国大陆',
    updateInfo: '全40集',
    isHot: false,
    isNew: false,
    tags: ['古装', '悬疑', '武侠'],
    longDescription: '《莲花楼》改编自藤萍的小说，讲述了昔日武林至尊李相夷隐姓埋名成为游医李莲花的故事。他以莲花楼为家，以医术为生，表面上不问世事，实则暗中调查一桩桩离奇案件。本剧将武侠与悬疑推理完美融合，每个案件都环环相扣，引人入胜。成毅饰演的李莲花机智幽默又深藏不露，给观众留下了深刻印象。',
  },
  {
    id: 'show-013',
    title: '辐射',
    category: '美剧',
    image: 'https://readdy.ai/api/search-image?query=American%20post-apocalyptic%20sci-fi%20series%20poster%20with%20wasteland%20theme%2C%20retro-futuristic%20aesthetic%2C%20orange%20and%20teal%20color%20palette%2C%20cinematic%20film%20poster%20style%2C%20dramatic%20wasteland%20landscape%2C%20clean%20product%20photography%20with%20epic%20composition&width=800&height=1120&seq=show-013&orientation=portrait',
    description: '核战争后的废土世界中，一群幸存者从舒适的避难所走出，踏入一个充满辐射和危险的陌生世界。',
    episodes: 8,
    currentEpisode: 8,
    status: '已完结',
    rating: 8.8,
    year: 2024,
    actors: ['艾拉·珀内尔', '沃尔顿·戈金斯', '亚伦·莫顿'],
    director: '乔纳森·诺兰',
    region: '美国',
    updateInfo: '全8集',
    isHot: false,
    isNew: true,
    tags: ['科幻', '末世', '冒险'],
    longDescription: '《辐射》改编自同名经典游戏系列，由《西部世界》主创乔纳森·诺兰执导。故事设定在一个被核战争摧毁的平行世界，幸存者们在被称为"避难所"的地下设施中生活了两百多年。当一个避难所的居民被迫回到地面时，他们发现了一个充满变异生物、强盗和各种派系的残酷世界。本剧在忠实还原游戏世界观的同时，创造了一个引人入胜的原创故事。',
  },
  {
    id: 'show-014',
    title: '向往的生活第七季',
    category: '综艺',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20variety%20show%20poster%20with%20rural%20countryside%20theme%2C%20warm%20natural%20sunlight%2C%20green%20pastoral%20scenery%20background%2C%20relaxing%20atmosphere%2C%20cinematic%20style%20with%20soft%20lighting%2C%20clean%20product%20photography%20with%20fresh%20natural%20composition&width=800&height=1120&seq=show-014&orientation=portrait',
    description: '黄磊与何炅带领新老朋友回归蘑菇屋，在田园生活中体验慢节奏的美好，每一期都有暖心故事和美味佳肴。',
    episodes: 14,
    currentEpisode: 14,
    status: '已完结',
    rating: 8.3,
    year: 2023,
    actors: ['黄磊', '何炅', '张艺兴', '彭昱畅', '张子枫'],
    director: '王征宇',
    region: '中国大陆',
    updateInfo: '全14集',
    isHot: false,
    isNew: false,
    tags: ['真人秀', '生活', '美食'],
    longDescription: '《向往的生活》第七季以"森林季"为主题，蘑菇屋家人们来到了内蒙古的森林深处。在这里，他们远离城市的喧嚣，过着自给自足的田园生活。每一期都有新老朋友到访，大家在蘑菇屋里聊天、做饭、劳动，分享各自的人生故事。本季在保持温馨治愈风格的同时，加入了许多新的惊喜和感动，是观众放松心情的最佳选择。',
  },
  {
    id: 'show-015',
    title: '排球少年！！垃圾场决战',
    category: '动漫',
    image: 'https://readdy.ai/api/search-image?query=Japanese%20sports%20anime%20poster%20with%20volleyball%20action%20theme%2C%20dynamic%20court%20scene%2C%20energetic%20orange%20and%20black%20color%20palette%2C%20anime%20film%20poster%20style%2C%20cinematic%20composition%20with%20dramatic%20lighting%2C%20clean%20product%20photography&width=800&height=1120&seq=show-015&orientation=portrait',
    description: '乌野高中排球部与音驹高中的宿命对决，这场被称为"垃圾场决战"的比赛，是两支球队多年情谊的巅峰时刻。',
    episodes: 1,
    currentEpisode: 1,
    status: '已完结',
    rating: 9.5,
    year: 2024,
    actors: ['村濑步', '石川界人', '日野聪', '入野自由'],
    director: '满仲劝',
    region: '日本',
    updateInfo: '剧场版',
    isHot: true,
    isNew: true,
    tags: ['运动', '热血', '青春'],
    longDescription: '《排球少年！！垃圾场决战》是排球少年系列的剧场版电影，讲述了乌野高中与音驹高中之间期待已久的对决。这场被称为"垃圾场决战"的比赛，是两支有着深厚渊源的球队的宿命之战。影片以令人惊叹的动画质量和紧凑的节奏，完美呈现了这场比赛的每一个精彩瞬间。无论是否看过TV动画，观众都能感受到排球运动的魅力和青春的热血。',
  },
  {
    id: 'show-016',
    title: '我的解放日志',
    category: '韩剧',
    image: 'https://readdy.ai/api/search-image?query=Korean%20slice-of-life%20drama%20poster%20with%20suburban%20commute%20theme%2C%20muted%20earthy%20color%20tones%2C%20contemplative%20mood%2C%20cinematic%20film%20poster%20style%2C%20soft%20natural%20lighting%2C%20clean%20product%20photography%20with%20quiet%20minimalist%20composition&width=800&height=1120&seq=show-016&orientation=portrait',
    description: '三兄妹每天从乡下通勤到首尔上班，在日复一日的平凡生活中，他们寻找着属于自己的解放之路。',
    episodes: 16,
    currentEpisode: 16,
    status: '已完结',
    rating: 9.0,
    year: 2022,
    actors: ['李民基', '金智媛', '孙锡久', '李艾儿'],
    director: '金锡允',
    region: '韩国',
    updateInfo: '全16集',
    isHot: false,
    isNew: false,
    tags: ['剧情', '治愈', '人生'],
    longDescription: '《我的解放日志》是一部温暖而深刻的韩国电视剧，讲述了住在京畿道的三兄妹每天往返首尔通勤的故事。他们的生活平凡而疲惫，但每个人都在用自己的方式寻找"解放"——那种让人生变得值得的珍贵时刻。剧中细腻地描绘了普通人的喜怒哀乐，每一句台词都像是对生活的温柔注解。金智媛和孙锡久的表演尤其出色，两人之间的化学反应令人心动。',
  },
];

export const categories = [
  { slug: 'guochanju', name: '国产剧', icon: 'ri-flag-line' },
  { slug: 'hanju', name: '韩剧', icon: 'ri-global-line' },
  { slug: 'meiju', name: '美剧', icon: 'ri-earth-line' },
  { slug: 'riju', name: '日剧', icon: 'ri-sun-line' },
  { slug: 'dongman', name: '动漫', icon: 'ri-movie-2-line' },
  { slug: 'zongyi', name: '综艺', icon: 'ri-tv-2-line' },
];

export const categorySlugMap: Record<string, string> = {
  'guochanju': '国产剧',
  'hanju': '韩剧',
  'meiju': '美剧',
  'riju': '日剧',
  'dongman': '动漫',
  'zongyi': '综艺',
};